import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpCreatePatient, HttpCreatePatientPayload} from './patients.http'
import {MUTATION_KEYS} from '@/queryClient'
import {AxiosError} from 'axios'
import {PatientExtended} from '@/features/patients/types'
import {parseAxiosPromise} from '@/axiosInstance'
import {captureException} from '@sentry/react'

export const useCreatePatient = (
    options?: Omit<
        UseMutationOptions<
            PatientExtended,
            AxiosError<{errors: {field: string; rule: string}[]}>,
            HttpCreatePatientPayload
        >,
        'mutationFn'
    >
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CREATE_PATIENT],
        mutationFn: payload =>
            parseAxiosPromise({
                axiosPromise: httpCreatePatient({
                    params: {responseType: 'extended'},
                    payload
                }),
                onZodError: captureException,
                responseShape: PatientExtended
            })
    })
}
